import { render, staticRenderFns } from "./dados.vue?vue&type=template&id=374d9230&scoped=true&"
import script from "./dados.vue?vue&type=script&lang=js&"
export * from "./dados.vue?vue&type=script&lang=js&"
import style0 from "./dados.vue?vue&type=style&index=0&id=374d9230&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374d9230",
  null
  
)

export default component.exports